import ShoppingCart from './shopping-cart';

const $ = window.jQuery;

// Value the hidden Gravity Forms field is prepopulated with, see
// GravityFormHooks::populateOfferRequestProducts(). It is replaced with the
// shopping cart contents before the form is submitted.
const PRODUCTS_PLACEHOLDER = '{{gp-groot-offer-request-products}}';
const PRODUCTS_JSON_PREFIX = 'gpgroot-products-json:';

// Earliest delivery date the customer may pick, in days from today.
const MINIMUM_DELIVERY_DAYS = 2;

/**
 * Locations is a map component
 */
class OfferRequest {
  constructor(selectors, shoppingCart) {
    this.selectors = selectors;
    this.shoppingCart = shoppingCart;

    this.offerRequestForm = $(selectors.offerRequestForm);

    this.offerRequestMenuItem = $('.menu-primary .menu-item-offer-request');
    this.offerRequestMenuLink = this.offerRequestMenuItem.find('> .nav-link');
    this.offerRequestBadge = null;
    this.offerRequestDropdownWrap = null;
    this.offerRequestDropdownList = null;
    this.mobileOfferRequestButton = $('.mobile-offer-request-btn');
    this.mobileOfferRequestBadge = null;

    this.shoppingCartContainer = $(selectors.shoppingCartContainer);
    this.productsContainer = $(selectors.productsContainer);
    this.addMoreProducts = $(selectors.addMoreProducts);

    this.form = $(selectors.form);
  }

  init() {
    this.initializeCartContents();
    this.initializeClickHandlers();
    this.initializeOfferRequestMenu();
    this.initializeMobileOfferRequestButton();
    this.initializeCartEvents();
    this.handleCartUpdate();
  }

  initializeCartContents() {
    const productsJson = this.shoppingCart.getProductsAsJson();
    this.includeMarkupForProductsInShoppingCart(productsJson);
  }

  initializeClickHandlers() {
    this.productsContainer.on('change', 'input.quantity', (e) => {
      const control = $(e.currentTarget);
      const productNode = control.parentsUntil('.product').parent();
      const index = productNode.index();

      const newQuantity = this.shoppingCart.updateQuantity(index, control.val());

      if (newQuantity === 0) {
        this.shoppingCart.removeProductAtIndex(index);
        productNode.remove();
      }
      this.saveShoppingCartProductsToHiddenField();
    });

    this.productsContainer.on('change', 'select.volume', (e) => {
      const control = $(e.currentTarget);
      const productNode = control.parentsUntil('.product').parent();
      const imageNode = productNode.find('.image-container img');

      const index = productNode.index();
      const imageUrl = control.find('option:selected').data('image-src');

      imageNode.fadeOut(50, () => {
        imageNode.attr('src', imageUrl);
        imageNode.fadeIn(250);
      });

      this.shoppingCart.updateVolume(index, control.val());
      this.saveShoppingCartProductsToHiddenField();
    });

    this.productsContainer.on('change', 'select.frequency', (e) => {
      const control = $(e.currentTarget);
      const productNode = control.parentsUntil('.product').parent();
      const index = productNode.index();

      this.shoppingCart.updateFrequency(index, control.val());
      this.saveShoppingCartProductsToHiddenField();
    });

    $(document).on('gform_confirmation_loaded', () => {
      const dataLayerProducts = [];
      const products = JSON.parse(this.shoppingCart.getProductsAsJson());

      this.shoppingCart.clear();
      this.shoppingCartContainer.hide();
      this.addMoreProducts.hide();

      products.forEach((product) => {
        dataLayerProducts.push({
          product: product.title,
          afvalstroom: product.wasteType,
          inhoud: product.volume,
          aantal: product.quantity,
        });
      });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'quotationRequest',
        status: 'Verzonden',
        producten: dataLayerProducts,
      });
    });

    $(document).on('gform_post_render', () => {
      // Gravity Forms rebuilt the form markup, so the hidden products field is
      // back to its placeholder value and has to be filled in again.
      this.saveShoppingCartProductsToHiddenField();
      OfferRequest.limitDatePickerToFutureDates('.offer-request-preferred-date-of-delivery');
    });
  }

  initializeOfferRequestMenu() {
    if (!this.offerRequestMenuItem.length || !this.offerRequestMenuLink.length) {
      return;
    }

    this.offerRequestMenuItem.addClass('menu-item-has-children');

    if (!this.offerRequestBadge) {
      this.offerRequestBadge = $('<span class="offer-request-badge badge badge-light"></span>');
      this.offerRequestBadge.hide();
      this.offerRequestMenuLink.append(this.offerRequestBadge);
    }

    if (!this.offerRequestDropdownWrap) {
      this.offerRequestDropdownWrap = $('<div class="sub-menu-wrap offer-request-sub-menu"></div>');
      this.offerRequestDropdownList = $('<ul class="sub-menu dropdown-menu"></ul>');
      this.offerRequestDropdownWrap.append(this.offerRequestDropdownList);
      this.offerRequestMenuItem.append(this.offerRequestDropdownWrap);
    }

    this.renderOfferRequestMenuFromCart();
  }

  includeMarkupForProductsInShoppingCart(productsJson) {
    $.ajax('/wp-json/gpgroot-webshop/v1/get-products', {
      cache: false,
      data: productsJson,
      method: 'POST',
      error: () => {
        this.shoppingCartContainer.html(OfferRequest.createErrorAlert('Er is iets fout gegaan bij het ophalen van de producten in uw winkelwagen. Neem als dit probleem zich voor blijft doen contact met ons op. Onze excuses voor het ongemak.'));
      },
      success: (data) => {
        this.shoppingCartContainer.html(data);

        if (productsJson && productsJson.length > 2) {
          this.addMoreProducts.show();
        }
        
        this.saveShoppingCartProductsToHiddenField();
      },
    });
  }

  /**
   * Resolved on every write instead of cached: Gravity Forms replaces the form
   * markup on gform_post_render (after a validation error for example), which
   * detaches any node we held on to and would leave the placeholder in place.
   */
  getHiddenProductsField() {
    return $(this.selectors.form).find('input[type="hidden"]').filter(function hasProductsValue() {
      const value = $(this).val() || '';
      return value === PRODUCTS_PLACEHOLDER || value.indexOf(PRODUCTS_JSON_PREFIX) === 0;
    });
  }

  saveShoppingCartProductsToHiddenField() {
    const productsJson = this.shoppingCart.getProductsAsJson();
    this.getHiddenProductsField().val(`${PRODUCTS_JSON_PREFIX}${productsJson}`);
  }

  initializeCartEvents() {
    window.addEventListener('shoppingCart:updated', () => {
      this.handleCartUpdate();
    });
  }

  handleCartUpdate() {
    this.saveShoppingCartProductsToHiddenField();
    this.renderOfferRequestMenuFromCart();
  }

  renderOfferRequestMenuFromCart() {
    if (!this.offerRequestMenuItem.length) {
      return;
    }

    const products = this.getCartProducts();
    const count = products.length;

    if (this.offerRequestBadge) {
      if (count > 0) {
        this.offerRequestBadge.text(count);
        this.offerRequestBadge.show();
      } else {
        this.offerRequestBadge.hide();
      }
    }

    if (this.mobileOfferRequestBadge) {
      if (count > 0) {
        this.mobileOfferRequestBadge.text(count);
        this.mobileOfferRequestBadge.show();
      } else {
        this.mobileOfferRequestBadge.hide();
      }
    }

    if (!this.offerRequestDropdownList) {
      return;
    }

    this.offerRequestDropdownList.empty();

    if (count === 0) {
      this.offerRequestDropdownList.append(OfferRequest.createEmptyDropdownItem());
      return;
    }

    products.forEach((product, index) => {
      this.offerRequestDropdownList.append(OfferRequest.createProductDropdownItem(product, index));
    });
    this.offerRequestDropdownList.append(OfferRequest.createOfferRequestLinkItem('Ga naar uw offerteaanvraag'));
  }

  initializeMobileOfferRequestButton() {
    if (!this.mobileOfferRequestButton.length) {
      return;
    }

    if (!this.mobileOfferRequestBadge) {
      this.mobileOfferRequestBadge = $('<span class="offer-request-badge badge badge-light"></span>');
      this.mobileOfferRequestBadge.hide();
      this.mobileOfferRequestButton.append(this.mobileOfferRequestBadge);
    }
  }

  getCartProducts() {
    const productsJson = this.shoppingCart.getProductsAsJson();

    if (!productsJson) {
      return [];
    }

    try {
      return JSON.parse(productsJson) || [];
    } catch (e) {
      return [];
    }
  }

  static createProductDropdownItem(product, index) {
    const item = $('<li class="menu-item nav-item"></li>');
    const label = $('<span class="nav-link"></span>');
    const title = product && product.title ? product.title : `Product ${index + 1}`;
    const quantity = product && product.quantity ? product.quantity : 1;
    const frequency = product && product.frequency ? product.frequency : '1x per 4 weken';

    label.text(`${quantity} x ${title}, ${frequency}`);
    item.append(label);

    return item;
  }

  static createEmptyDropdownItem() {
    return OfferRequest.createOfferRequestLinkItem('Voeg producten toe aan uw offerte', 'offer-request-empty-nav-item');
  }

  static createOfferRequestLinkItem(text = 'Offerte aanvragen', extraClass = '') {
    const item = $(`<li class="menu-item nav-item offer-request-link ${extraClass}"></li>`);
    const link = $('<a class="nav-link" href="/offerte/"></a>');

    link.text(text);
    item.append(link);

    return item;
  }

  static createErrorAlert(message) {
    const markup = `
      <div class="alert alert-danger">${message}</div>
    `;

    return markup;
  }

  static limitDatePickerToFutureDates(selector) {
    $(`${selector} .datepicker`).attr('autocomplete', 'off');
  }

  /**
   * Keeps the earliest selectable delivery date MINIMUM_DELIVERY_DAYS ahead.
   *
   * Gravity Forms initialises the datepicker itself and passes its options
   * through this filter, both for the jQuery UI datepicker it used up to 2.10 and
   * for the library that replaced it in 3.0. Going through the filter means we no
   * longer touch $.fn.datepicker, which 3.0 stopped loading, and Gravity Forms
   * keeps ownership of the localisation. Both implementations read minDate as a
   * number of days from today.
   */
  static limitGravityFormsDatePicker(selector) {
    const gf = window.gform;

    if (!gf || typeof gf.addFilter !== 'function') {
      return;
    }

    gf.addFilter('gform_datepicker_options_pre_init', (options, formId, fieldId) => {
      const field = document.getElementById(`field_${formId}_${fieldId}`);

      if (!field || typeof field.matches !== 'function' || !field.matches(selector)) {
        return options;
      }

      return Object.assign({}, options, { minDate: MINIMUM_DELIVERY_DAYS });
    });
  }
}

$(document).ready(() => {
  // Registered before anything else: Gravity Forms builds its datepicker lazily
  // on first focus, so the filter only has to be in place before the customer
  // reaches the field.
  OfferRequest.limitGravityFormsDatePicker('.offer-request-preferred-date-of-delivery');

  const shoppingCart = new ShoppingCart();

  const offerRequest = new OfferRequest({
    offerRequestForm: '.offer-request-form',
    shoppingCartContainer: '.shopping-cart-contents',
    productsContainer: '.offer-request-form .products',
    addMoreProducts: '.add-more-products',
    form: '.offer-request-form form',
  }, shoppingCart);

  // Initialise the cart before touching the datepicker, so the shopping cart
  // and the hidden products field never depend on the datepicker succeeding.
  offerRequest.init();

  OfferRequest.limitDatePickerToFutureDates('.offer-request-preferred-date-of-delivery');
});
